
const HeaderBanner = (props: any) => {
    return (
        <>
            <section className="page-title page-title-1" id="page-title">
                <div className="page-title-wrap bg-overlay bg-overlay-dark">
                    <div className="service-image">
                        <img src={props?.imagePath} alt="Background" style={{ width: '100%' }} />
                        <h1 className="banner-title">{props?.heading}</h1>
                    </div>
                </div>
            </section>
        </>)
}

export default HeaderBanner;